import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Icon, Header, Button, Segment } from 'semantic-ui-react';
import { getAllSavedSearch, patchSaveSearch, getMineSavedSearch, runInventoryReportById } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ReactTable from 'react-table';
import { NotificationManager } from 'react-notifications';
import MessageBox from '../../ui/MessageBox';
class SavedSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savedItems: [],
            cltClientIds: [],
            positive: true,
            rowIndex: 0,
            msg12open: false,
            mine: [],
            all: [],
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "reports_inventory-saved-searches.md");
        this.loadMine();
    }

    loadMine = () => {
        getMineSavedSearch(this.props.items.currentCorporate).then((response) => {
            if (response instanceof Object) {
                this.setState({
                    savedItems: response,
                    mine: response,
                    positive: true,
                    all: [],
                })
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.loadMine();
        }

    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    open = (value) => {
        this.setState({
            msg12open: true,
            rowIndex: value
        })
    }
    handlePatch = (id, value, type) => {
        let patchObject = {
            [type]: value,
            issId: id
        }
        patchSaveSearch(this.props.items.currentCorporate, patchObject).then((response) => {
            if (response !== null) {
                if (type === "issDeleted") {
                    this.setState((prevState, props) => {
                        return {
                            savedItems: this.state.savedItems.filter((u) => {
                                return u.issId !== id;
                            }),
                            msg12open: false
                        };
                    });
                    NotificationManager.success('Success', 'Deleted successfully.');
                } else {
                    this.setState((prevState, props) => {
                        return {
                            savedItems: this.state.savedItems.map((u) => {
                                if (u.issId === id) {
                                    u.issShare = value;
                                }
                                return u;
                            })
                        };
                    });
                    if (value === 'N') {
                        NotificationManager.success('Success', 'Removed sharing successfully.');
                    } else {
                        NotificationManager.success('Success', 'Shared successfully.');
                    }
                }
            }
        })
    }

    showMine = () => {
        this.setState({
            positive: true,
            savedItems: this.state.mine
        })
    }

    showAll = () => {
        this.setState({
            positive: false
        }, () => {
            if (this.state.all.length === 0) {
                this.showAllSaved()
            } else {
                this.setState({
                    savedItems: this.state.all
                })
            }
        })
    }

    showAllSaved = () => {
        getAllSavedSearch(this.props.items.currentCorporate).then((response) => {
            if (response instanceof Object) {
                this.setState({
                    savedItems: response,
                    all: response
                })
            }
        })
    }

    runInventoryReport = (issId) => {
        runInventoryReportById(this.props.items.currentCorporate, issId).then((response) => {
            if (response !== null) {
                let disposition = response.request.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    let matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        let filename = matches[1].replace(/['"]/g, '');
                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE workaround for "HTML7007: One or more blob URLs were 
                            // revoked by closing the blob for which they were created. 
                            // These URLs will no longer resolve as the data backing 
                            // the URL has been freed."
                            window.navigator.msSaveBlob(new Blob([response.data]), filename);
                        } else {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                        }
                    }
                }
            }
        })
    }

    render() {
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Reports" child={[{ name: "Inventory", url: "/report/inventory" }, { name: "Saved Search Preferences", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment.Group horizontal>
                                    <Segment color="grey" inverted>
                                        <Header as="h4">
                                            <Icon name="save" />
                                            <div className="content">
                                                Saved Search Preferences
                                             </div>
                                        </Header>
                                    </Segment>
                                    <Segment color="grey" inverted>
                                        <div className="ui right floated small buttons">
                                            <Button.Group width={2}>
                                                <Button className={this.state.positive ? "positive" : ""} onClick={this.showMine}>Show Mine</Button>
                                                <Button.Or />
                                                <Button className={!this.state.positive ? "positive" : ""} onClick={this.showAll}>Show All</Button>
                                            </Button.Group>
                                        </div>
                                    </Segment>
                                </Segment.Group>
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.savedItems.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                    data={this.state.savedItems}
                                    getNoDataProps={() => {
                                        return { style: { display: 'none' } };
                                    }}
                                    columns={[{
                                        Header: 'Corporate',
                                        accessor: 'issCrpRefId',
                                        width: 100
                                    }, {
                                        Header: 'Title',
                                        accessor: 'issName',
                                    }, {
                                        Header: 'Description',
                                        accessor: 'issDesc',
                                    }, {
                                        Header: 'Creator',
                                        accessor: 'issCreatedUserName',
                                    }, {
                                        Header: 'Created Date',
                                        accessor: 'issCreatedDate',
                                        width: 100
                                    }, {
                                        Header: 'Run',
                                        style: {
                                            textAlign: "center"
                                        },
                                        filterable : false,
                                        width: 80,
                                        Cell: row => (
                                            <Button onClick={() => { this.runInventoryReport(row.original.issId) }} className="icon mini" data-inverted="" data-tooltip="Run" data-position="top right" ><Icon name="cogs" /></Button>
                                        )
                                    }, {
                                        Header: 'Share?',
                                        width: 80,
                                        style: {
                                            textAlign: "center"
                                        },
                                        filterable : false,
                                        Cell: row => (
                                            <Button onClick={(e) => { this.handlePatch(row.original.issId, (row.original.issShare === 'Y' ? "N" : "Y"), "issShare") }} className="icon mini" data-inverted="" data-tooltip="Share" data-position="top right" >{row.original.issShare === 'Y' ? "Yes" : "No"}</Button>
                                        )
                                    }, {
                                        Header: 'Actions',
                                        style: {
                                            textAlign: "center"
                                        },
                                        width: 100,
                                        filterable : false,
                                        Cell: row => (
                                            <div>
                                                <Button onClick={(e) => { this.open(row.original.issId) }} className="icon mini" data-tooltip="Resolve" data-inverted="" data-position="top right" ><Icon name="trash" /></Button>
                                                <Button as={Link} to={"/report/inventory/" + row.original.issId} className="icon mini" data-tooltip="Update" data-position="top right" data-inverted=""><Icon name="pencil" /></Button>
                                            </div>
                                        )
                                    }]}
                                />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={12} open={this.state.msg12open} close={() => { this.setState({ msg12open: false }) }} content="Are you sure you want to delete?" contentTitle="Delete Saved Search?" yesHandle={() => { this.handlePatch(this.state.rowIndex, 'Y', "issDeleted") }} />
            </div>
        );
    }
}
export default SavedSearch;


// WEBPACK FOOTER //
// ./src/app/ui/reports/SavedSearch.js